import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReportingUserService } from '@http/clients/reporting-app/reporting-user.service';
import { SearchUserDto } from '@reporting-proxies';
import { ReportsService } from '@services/reports.service';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-user-editor',
    templateUrl: './reporting-user-editor.component.html',
    styleUrls: ['./reporting-user-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportingUserEditorComponent extends EditorComponentBase<number[] | null> implements OnInit, OnDestroy {
    items: SearchUserDto[];
    selectedItems?: SearchUserDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportingUserService: ReportingUserService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    async ngOnInit(): Promise<void> {
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty !== null && this.bindingProperty?.length) {
                this.selectedItems = await this.reportingUserService.getByIds(this.bindingProperty);
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    async onSelectedItemsChange(): Promise<void> {
        if (this.selectedItems) {
            this.bindingProperty = this.selectedItems.length ? this.selectedItems.map((item) => item.id) : null;
            this.valueChange.emit();
        }
    }

    async onEntityTextChange(text: string) {
        this.items = await this.reportingUserService.search(text);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
